module.exports = __webpack_public_path__ + "img/6.09186579.jpg";